// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"86c0b974","461":"4c4fd403","474":"b3504b11","513":"2ace1554","703":"f8539855","787":"627470b2","796":"fc61dec0","987":"00c1d2e6"}[chunkId] + ".chunk.js";
};